<ng-container *ngIf="action$ | async"></ng-container>

<ng-container *ngIf="panel$ | async as panel">
  <csl-item-card
    [imageFit]="'scale-down'"
    [cleanable]="!!panel.panelOutline?.millings[0]"
    [disabled]="disabled"
    data-testid="millingsItemCard"
    [iconLink]="getIconLink(panel.panelOutline?.millings[0])"
    (selectClicked)="changeMilling(panel)"
    (cleaned)="remove(panel.panelOutline?.millings[0], panel)"
    i18n-title
    [title]="'Фрезеровка'"
    [description]="panel.panelOutline?.millings[0]?.name || 'Выберите фрезеровку'">
  </csl-item-card>
</ng-container>
